import React from 'react'
import { Provider } from 'react-redux'
import { Route } from 'react-router'
import { Router } from 'react-router-dom'
import {createBrowserHistory} from 'history'
import AnimatedRouterSwitch from '../core/components/animated-router-switch/AnimatedRouterSwitch'
import ScrollToTop from '../core/components/scroll-to-top/ScrollToTop'
import fontawesome from '../core/fonts/fontawesome'
import home from "./home";
import topic from "./topic";
import grandmaster from "./grandmaster"
import search from "./search"
import user from "./user"
import subjectsRoute from './home/subjects/index'
import ModalRoot from '../core/components/modals/ModalRoot'
import ToastManager from '../core/components/toasts/ToastManager'
import aboutUsRoute from './about-us/index'
import NotFound from './error/404'
import misc from './misc'
import spark from './spark/index'
import ramanujanRoute from './ramanujan/index'
import NYAS from './NYAS/index'
import dashboardRoute from './dashboard_v3/index'
import Editor from './editor_v3/index';
import SlackFeedback from '../core/components/feedback/slack-feedback'
// import scholarshipRoute from './scholarship/index'
// import defaultTheme from '../core/feedback/themes/index'

//import TypographyTest from '../core/components/typography/TypographyTest'

// import * as mixpanel from '../util/mixpanel';
const history = createBrowserHistory()
const initHistory= (history) => {
  // mixpanel.initMixpanel();
  // mixpanel.track('pageview');

  history.listen((location) => {
    window.gtag('config', 'G-TPQMDR0GBN', {'page_path': `${location.pathname}${location.search}`})
    // mixpanel.track('pageview');
  })
}
initHistory(history)

class Root extends React.PureComponent {
  componentDidMount() {
    if (process.env.NODE_ENV !== 'production') { // If not production, add redux_dev_tools
      window.V1Url = 'http://v1.localexpii.com:5000'
      window['ga-disable-G-TPQMDR0GBN'] = true
    }
    
    // window.prerenderReady tells prerender.io when the page is loaded
    function checkLoading(iterationsLeft) {
      if (document.querySelector('.lds-spinner') == null || iterationsLeft === 0) {
        window.prerenderReady = true
      }
      else {
        setTimeout(checkLoading, 100, iterationsLeft-1)
      }
    }
    setTimeout(checkLoading, 500, 200)
  }
  render() {
    const {store} = this.props
    return (
      <Provider store={store}>
        <Router history={history}>
          <ScrollToTop>
            <div className="app-container">
              <Route path="/" component={ModalRoot} />
              <Route path="/" component={ToastManager} />
              <AnimatedRouterSwitch
                shouldTransitionFunc={(location)=>{
                  if (location.pathname === '/search') {
                    return 2
                  }
                  return 1
                }}>
                {user}
                {topic}
                {grandmaster}
                {search}
                {subjectsRoute}
                {misc}
                {aboutUsRoute}
                {home}
                {
                  //<Route path='/test' component={TypographyTest} />
                }
                {ramanujanRoute}
                {spark}
                {NYAS}
                {dashboardRoute}
                {Editor}
                <Route component={NotFound} />
              </AnimatedRouterSwitch>
              <SlackFeedback
                // open
                // theme={defaultTheme}
                channel="#user-feedback"
                // onSubmit={(payload, success, error) =>
                //   sendToSlack(payload, success, error)
                // }
                // onImageUpload={(file, success, error) =>
                //   uploadImage(file, success, error)
                // }
              />
            </div>
          </ScrollToTop>
        </Router>
      </Provider>
    )
  }
}

export default Root



// WEBPACK FOOTER //
// ./src/domains/Root.js